import { consentsApi } from 'common/modules/ReactShared';
import { createAsyncThunk } from '@reduxjs/toolkit';

const sendToSConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendToSConsent_request',
  async (data, { rejectWithValue }) => {
    try {
      return await consentsApi.sendToSConsent(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText || 'Error happened while trying to send ToS consent'
      );
    }
  }
);

const sendMarketingConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendMarketingConsent_request',
  async (data, { rejectWithValue }) => {
    try {
      return await consentsApi.sendMarketingConsent(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText ||
          'Error happened while trying to send Marketing consent'
      );
    }
  }
);

const sendCookiesConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendCookiesConsent_request',
  async (data, { rejectWithValue }) => {
    try {
      return await consentsApi.sendCookiesConsent(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText ||
          'Error happened while trying to send Cookies consent'
      );
    }
  }
);

const sendResearchConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendResearchConsent_request',
  async (data, { rejectWithValue }) => {
    try {
      return await consentsApi.sendResearchConsent(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText ||
          'Error happened while trying to send Research consent'
      );
    }
  }
);

const sendThirdStateConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendThirdStateConsent_request',
  async (data, { rejectWithValue }) => {
    try {
      return await consentsApi.sendThirdStateConsent(data).catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText ||
          'Error happened while trying to send Third State consent'
      );
    }
  }
);

const sendLegalGroundsConsent = createAsyncThunk<unknown, any, { rejectValue: string }>(
  'consents/sendLegalGroundConsent_request',
  async (_, { rejectWithValue }) => {
    try {
      return await consentsApi.sendLegalGroundsConsent().catch((err) => {
        return rejectWithValue(err?.message || '');
      });
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.statusText ||
          'Error happened while trying to send Legal Grounds consent'
      );
    }
  }
);

export const consentsActions = {
  sendToSConsent,
  sendMarketingConsent,
  sendCookiesConsent,
  sendResearchConsent,
  sendThirdStateConsent,
  sendLegalGroundsConsent
};
